
<template>
  <v-card class="elevation-0 transparent page-card">
    <v-skeleton-loader
      class="mx-auto"
      elevation="2"
      max-width="360"
      type="card-avatar, article, actions"
      boilerplate
    ></v-skeleton-loader>

    <div class="skyscrapper elevation-4">

    </div>
  </v-card>
</template>
  
  <script>
export default {
  data() {
    return {};
  },
  components: {},
};
</script>


<style lang="scss" scoped>
.skyscrapper{
  width: 120px;
  height: 600px;
  border-radius: 12px;
  background-color: #0C5AD5;
  display: flex;
  justify-content: center;
  align-items: center;
  position: a;
}
</style>